<template>
  <section class="section">
    <box>
      <div class="columns">
        <div class="column">
          <tabs :theme="$_ui_theme_tabs">
            <tab
              :title="$l('components.settings.copyrights', 'Copyrights')"
              hash="copyrights"
            >
              <SettingsCopyrightsV2></SettingsCopyrightsV2>
            </tab>
            <tab
              :title="
                $l('components.settings.scheduleUpdate', 'Schedule update')
              "
              hash="schedule-update"
            >
              <SettingsScheduleUpdateV2></SettingsScheduleUpdateV2>
            </tab>
          </tabs>
        </div>
      </div>
    </box>
  </section>
</template>

<script>
import { Tabs, Tab } from "@cyradar/ui";
import SettingsCopyrightsV2 from "@/components/SettingsCopyrightsV2.vue";
import SettingsScheduleUpdate from "@/components/SettingsScheduleUpdate.vue";
import SettingsScheduleUpdateV2 from "@/components/SettingsScheduleUpdateV2.vue";

import TimePicker from "@/components/TimePicker.vue";
import SettingsCopyrights from "@/components/SettingsCopyrights.vue";

export default {
  name: "Settings",
  components: {
    SettingsCopyrightsV2,
    SettingsScheduleUpdate,
    SettingsScheduleUpdateV2,

    SettingsCopyrights,
    TimePicker,
    Tabs,
    Tab,
  },

  data() {
    return {};
  },
};
</script>
